import SvarBasicGantt from "./svar-cases/SvarBasicGantt.jsx";
import HeliosPlanner from "./planner/HeliosPlanner.jsx";

export const svarLinks = [
  ["/svar/next/:skin", "Helios Planner (custom)", HeliosPlanner],
  ["/svar/basic/:skin", "Helios Planner", HeliosPlanner],
  ["/svar/legacy/:skin", "SVAR Basic Gantt (legacy)", SvarBasicGantt],
];
